import React from 'react';
import {
  AppBar, Toolbar, Typography, Drawer, List, ListItem, ListItemIcon, ListItemText,
  CssBaseline, Box, TextField, Select, MenuItem, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Button, IconButton, Chip, Avatar
} from '@mui/material';
import {
  Home, Dashboard, ShoppingCart, Assignment, Message, People, Help, Settings,
  Search, GetApp, MoreVert
} from '@mui/icons-material';

function DashboardLayout() {
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <Typography variant="h6" noWrap component="div">
            Acme Co.
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: 240,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: 240, boxSizing: 'border-box' },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto' }}>
          <List>
            {['Home', 'Dashboard', 'Orders', 'Tasks', 'Messages', 'Users', 'Support', 'Settings'].map((text, index) => (
              <ListItem button key={text} selected={text === 'Orders'}>
                <ListItemIcon>
                  {index === 0 && <Home />}
                  {index === 1 && <Dashboard />}
                  {index === 2 && <ShoppingCart />}
                  {index === 3 && <Assignment />}
                  {index === 4 && <Message />}
                  {index === 5 && <People />}
                  {index === 6 && <Help />}
                  {index === 7 && <Settings />}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItem>
            ))}
          </List>
        </Box>
        <Box sx={{ position: 'absolute', bottom: 0, width: '100%', p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Avatar sx={{ mr: 2 }}>SK</Avatar>
            <Typography variant="subtitle2">Siriwat K.</Typography>
          </Box>
        </Box>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <Typography variant="h4" sx={{ mb: 2 }}>Orders</Typography>
        <Box sx={{ display: 'flex', mb: 2 }}>
          <TextField
            variant="outlined"
            placeholder="Search for order"
            size="small"
            sx={{ mr: 2, flexGrow: 1 }}
            InputProps={{
              startAdornment: <Search />,
            }}
          />
          <Select value="" displayEmpty size="small" sx={{ mr: 2 }}>
            <MenuItem value="" disabled>Filter by status</MenuItem>
          </Select>
          <Select value="all" size="small" sx={{ mr: 2 }}>
            <MenuItem value="all">All</MenuItem>
          </Select>
          <Select value="all" size="small">
            <MenuItem value="all">All</MenuItem>
          </Select>
        </Box>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Invoice</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Customer</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* Add table rows here */}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}

export default DashboardLayout;